<template>
  <div id="app" class="appBox">
    <Index />
  </div>
</template>

<script>
import Index from './pages/Index.vue';
export default {
  components: {
    Index,
  },
  name: "App",
};
</script>
<style>
@import "./assets/icon/iconfont.css";
@import "./assets/icon/iconfont-weapp-icon.css";
@import "./assets/icon/iconfont-weapp-icon-sensor.css";
@import "./assets/css/common.css";

html,
body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  background: rgba(242, 244, 247, 1);
}

.appBox {
  width: 100%;
  height: 100%;
}
</style>
